export const millisecondsToMinutes = (milliseconds: number): number => {
  return milliseconds / (60 * 1000);
};

export const stripAppointmentTypeFromAppointmentName = (
  rawAppointmentName: string | undefined
): string => {
  if (!rawAppointmentName) {
    return '';
  }

  return rawAppointmentName.split('[')[0].trim();
};

export const safeJsonParse = <T>(value: string, fallback: T): T => {
  try {
    return JSON.parse(value) as T;
  } catch (error) {}

  return fallback;
};

export const getRoomUuidFromChannel = (input: string, prefix: string = 'meeting-room-') => {
  if (typeof input !== 'string') {
    return '';
  }

  const s = input.trim();
  if (!s.startsWith(prefix)) {
    return '';
  }

  const candidate = s.slice(prefix.length);
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  return uuidRegex.test(candidate) ? candidate : '';
};
